import { render } from "./NoFoundView.vue?vue&type=template&id=9820f376"
import script from "./NoFoundView.vue?vue&type=script&lang=js"
export * from "./NoFoundView.vue?vue&type=script&lang=js"

import "./NoFoundView.vue?vue&type=style&index=0&id=9820f376&lang=css"

import exportComponent from "D:\\weixin_repair\\ideamerry_open_repair_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__